// removed by extract-text-webpack-plugin
module.exports = {"flexPosition":"_2Y-HUgLhDUXGrmjKKQYt8z","title":"_3iP7xEEVwBFea9lKAweHDd","subTitle":"_1jQRSEnxBjnGfbF2NU8rHQ","buttonWrapper":"VwMSt1JrccKARcZUc4IZi"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/QuickTeamAdd/QuickTeamAdd.scss
// module id = 1837
// module chunks = 0